import { render, staticRenderFns } from "./course-card.vue?vue&type=template&id=54faf7d6&scoped=true"
import script from "./course-card.vue?vue&type=script&lang=js"
export * from "./course-card.vue?vue&type=script&lang=js"
import style0 from "./course-card.vue?vue&type=style&index=0&id=54faf7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54faf7d6",
  null
  
)

export default component.exports